import React from 'react';
import PropTypes from 'prop-types';
import BaseModal from 'components/BaseModal';
import { Typography, Box, Button } from '@mui/material';
import { useStyles } from './styles';

const Props = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clickBtnWhite: PropTypes.func.isRequired,
  clickBtnPurple: PropTypes.func.isRequired,
};

export default function CartOfferTrial({ open, onClose, clickBtnWhite, clickBtnPurple }) {
  const classes = useStyles();

  return (
    <BaseModal
      size="md"
      open={open}
      actionButton={false}
      cancelButton={false}
      content={
        <Box>
          <Typography className={classes.title}>Leaving so soon?</Typography>

          <Typography className={classes.textInfo}>
            Before you go, how about trying out 7 days <br /> of Researcher Plan's benefits for
            free?{' '}
          </Typography>

          <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
            <img src="/images/person-cart-offer-trial.svg" alt="person offer trial image" />

            <Box ml={6}>
              <Box display="flex" pb={1}>
                <img src="/images/check-icon-offer-trial.svg" alt="check icon" />
                <Typography className={classes.textBenefits}>No more watermarks</Typography>
              </Box>

              <Box display="flex" pb={1}>
                <img src="/images/check-icon-offer-trial.svg" alt="check icon" />
                <Typography className={classes.textBenefits}>
                  Unlimited scientific illustrations
                </Typography>
              </Box>

              <Box display="flex" pb={1}>
                <img src="/images/check-icon-offer-trial.svg" alt="check icon" />
                <Typography className={classes.textBenefits}>Unlimited editable figure</Typography>
              </Box>

              <Box display="flex" pb={1}>
                <Box mt={1}>
                  <img src="/images/check-icon-offer-trial.svg" alt="check icon" />
                </Box>
                <Typography className={classes.textBenefits}>
                  5 custom illustrations requests <br /> per month
                </Typography>
              </Box>

              <Box display="flex" pb={1}>
                <img src="/images/check-icon-offer-trial.svg" alt="check icon" />
                <Typography className={classes.textBenefits}>High definition downloads</Typography>
              </Box>
            </Box>
          </Box>

          <Box display="flex" justifyContent="space-between" px={25} alignItems="center" mt={4}>
            <Button onClick={clickBtnWhite} className={classes.buttonWhite}>
              No, I don't want it
            </Button>

            <Button onClick={clickBtnPurple} className={classes.buttonPurple}>
              Yes, I want to Start Free Trial Now
            </Button>
          </Box>
        </Box>
      }
      onClose={onClose}
    />
  );
}
